import { z } from 'zod';
export const CAPTURE_DESTINATIONS = ['inbox', 'todo', 'research', 'guidance'];
export const CaptureDestinationSchema = z.enum(CAPTURE_DESTINATIONS);
/** URL/text/mixed Shortcut input; unknown fields cannot request wider privileges. */
export const CaptureInputSchema = z
    .object({
    text: z.string().max(20_000).optional(),
    destination: CaptureDestinationSchema.optional(),
    url: z.string().max(4_000).optional(),
    title: z.string().max(240).optional(),
    idempotency_key: z.string().min(1).max(128).optional(),
})
    .strict()
    .refine((value) => Boolean(value.text?.trim() || value.url?.trim()), 'text or URL is required');
